import { Button } from "@workspace/ui/components/button";
import { ClipboardList, Search, Zap } from "lucide-react";
import Link from "next/link";
import { Feature, type FeatureItem } from "./feature";

const features: FeatureItem[] = [
  {
    title: "Easy job discovery",
    description:
      "Find relevant job opportunities with our smart search and filtering system.",
    icon: <Search className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "User-friendly interface",
    description:
      "Navigate through job listings with our intuitive and responsive design.",
    icon: <Zap className="h-5 w-5 md:h-6 md:w-6" />,
  },
  {
    title: "Job application tracking",
    description:
      "Keep track and manage all your job applications in one organized place",
    icon: <ClipboardList className="h-5 w-5 md:h-6 md:w-6" />,
  },
];

export function EmployeesFeaturesSection() {
  return (
    <section className="py-16 md:py-20 lg:py-24" id="job-seekers">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            For job seekers
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            Find your dream job with tools designed to make your job search
            simple, efficient, and successful.
          </p>
        </div>

        <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 py-6 sm:grid-cols-2 md:py-10 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Feature
              {...feature}
              index={index}
              key={feature.title}
              totalFeatures={features.length}
            />
          ))}
        </div>

        <div className="mt-8 text-center md:mt-12">
          <Button asChild size="lg">
            <Link href="/job-listings">Find a job</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
